import '../../css/FormTemplate.css'
import { IFormNewTypeSelectInputDivTemplate } from "../../interfaces/interface";

const FormNewTypeSelectInputDivTemplate = (props:IFormNewTypeSelectInputDivTemplate) => {

    return (              
                <div className='form-template-input-div-without-icon' >
                    <select className="form-template-input-select" 
                        name={props.id}
                        id={props.id} 
                        onChange={props.selectChangeHandler}
                        disabled={props.disabled}
                    >
                        <option disabled  selected={props.defaultSelectValue === ""}
                         className="form-template-select-option" value="">
                            Please choose type... 
                        </option>
                        <option className="form-template-select-option" value="addNewType">+ add new type</option>

                        { 
                            props.optionList &&
                                props.optionList.map((option) => {
                                    if(props.defaultSelectValue === option){
                                        return <option selected className="form-template-select-option" value={option}>{option}</option>
                                    }
                                    return <option className="form-template-select-option" value={option}>{option}</option>
                                })
                        }
                    </select>
                </div>
    );
};
                
export default FormNewTypeSelectInputDivTemplate;